import { QueryClient } from '@tanstack/react-query';

// Configure the QueryClient with optimized settings
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry failed queries to handle temporary network issues
      retry: 1,
      // Keep cached data when window refocuses
      refetchOnWindowFocus: false,
      // How long the data remains "fresh"
      staleTime: 5 * 60 * 1000, // 5 minutes
      // How long unused data is kept in cache
      gcTime: 10 * 60 * 1000, // 10 minutes
      // Don't refetch data automatically when user navigates back
      refetchOnReconnect: false
    }
  }
});
